<template>
  <div
    class="sort"
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="loading"
    infinite-scroll-distance="10"
  >
    <div class="hander">
      <van-icon name="arrow-left" @click="goBack" class='nav_goback' />
    </div>
    
    <router-link tag="div" :to="{name:'us',query:{id:item.id}}" v-for="item in list" :key="item.id" class="item">
      <span>{{ item.title }}</span>
      <img src="../../assets/my/next2.png" alt />
    </router-link>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      page: 1,
      noData:false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$http({
        url: "helpList",
        data:{
          page:this.page
        }
      }).then(res => {
        this.page = ++res.nowPage;
        if (res.nowPage == 1) {
          this.list = res._list;
        } else {
          this.list = this.list.concat(res._list);
        }
        if(res._list.length ==0) this.noData = true
      });
    },
    loadMore() {
      if(this.noData) return 
      this.loading = true;
      setTimeout(() => {
        this.getList()

        this.loading = false;
      }, 2500);
    }
  }
};
</script>


<style lang="less" scoped>
.sort {
  // background-color: #000;

  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    color: #333;
    width: 100%;
    height: 110px;
    padding: 0 24px;
    box-sizing: border-box;
    margin-bottom: 2rpx;
    background-color: #fff;
    img {
      width: 20px;
    }
  }
  .hander{
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background-color: rgba(255,255,255,.6);
    margin-bottom: 10px;
  }
}
</style>
